const STATUS_TRANSLATIONS = new Map([
  ['initial', 'À cobrar'],
  ['due', 'Atrasado'],
  ['cancelled', 'Cancelado'],
  ['paid', 'Pago']
]);

export const invoiceStatus = (status: string): string =>
  STATUS_TRANSLATIONS.get(status) || status;
